module.exports = __webpack_public_path__ + "img/operate_btn_1.82f58e35.png";